export const GET_ACTIVE_OBJECT_ENTITY = 'GET_ACTIVE_OBJECT_ENTITY';
export const SET_ACTIVE_OBJECT_ENTITY = 'SET_ACTIVE_OBJECT_ENTITY';
export const UPDATE_ASSOCIATED_OBJECT = 'UPDATE_ASSOCIATED_OBJECT';
export const UPDATE_ACTIVE_OBJECT = 'UPDATE_ACTIVE_OBJECT';
export const RESET_OBJECT_ENTITY = 'RESET_OBJECT_ENTITY';
export const initialState = {
  objectEntity: {
    id: '',
    properties: {}
  }
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_ACTIVE_OBJECT_ENTITY:
      return Object.assign({}, state, {
        objectEntity: action.payload
      });
    case UPDATE_ACTIVE_OBJECT:
      return Object.assign({}, state, {
        objectEntity: Object.assign({}, state.objectEntity, {
          properties: Object.assign({}, state.objectEntity.properties, action.payload)
        })
      });
    case RESET_OBJECT_ENTITY:
      return Object.assign({}, state, {
        objectEntity: {
          id: '',
          properties: {}
        }
      });
    default:
      return state;
  }
};